


















import {Vue, Component } from 'vue-property-decorator';
import { Title } from '@/components/Title';
import TabNavigator from '@/components/TabNavigator';
import VLazyImage from 'v-lazy-image';

@Component({
  name: 'NavigationPanel',
  components: {
    TabNavigator, Title, VLazyImage,
  },
  props: {
    tabs: {
      type: Array,
      default: () => [],
    },
    headerBgImg: {
      type: Object,
      default: () => {},
    },
    titlePage: {
      type: String,
      default: '',
    },
    height: {
      type: Number,
      default: 0,
    },
  },
  computed: {
    srcImg: {
      get() {
        return !!this.headerBgImg
          && !!this.headerBgImg.image && `${this.headerBgImg.image[3600]}` || '';
      },
    },

    srcImgPlaceholder: {
      get() {
        return !!this.headerBgImg
          && !!this.headerBgImg.image && `${this.headerBgImg.image[400]}` || '';
      },
    },

    srcSet: {
      get() {
        return `${this.headerBgImg.image[400]} 400w,
                ${this.headerBgImg.image[800]} 800w,
                ${this.headerBgImg.image[1300]} 1300w,
                ${this.headerBgImg.image[1900]} 1900w,
                ${this.headerBgImg.image[3600]} 3600w`;
      },
    },

  },
})
export default class NavigationPanel extends Vue {}
